{
  "round": {
    "x": 57,
    "y": 49,
    "w": 166,
    "h": 41,
    "lane": {
      "x": 40,
      "y": 42,
      "w": 196,
      "h": 54
    }
  },
  "target.label": {
    "x": 494,
    "y": 270,
    "w": 117,
    "h": 25,
    "lane": {
      "x": 486,
      "y": 268,
      "w": 128,
      "h": 30
    }
  },
  "question": {
    "x": 132,
    "y": 504,
    "w": 682,
    "h": 132,
    "lane": {
      "x": 80,
      "y": 494,
      "w": 780,
      "h": 142
    }
  },
  "instruction": {
    "x": 141,
    "y": 632,
    "w": 673,
    "h": 59,
    "lane": {
      "x": 80,
      "y": 632,
      "w": 782,
      "h": 62
    }
  },
  "score.title": {
    "x": 323,
    "y": 1380,
    "w": 294,
    "h": 63,
    "lane": {
      "x": 300,
      "y": 1380,
      "w": 340,
      "h": 68
    }
  },
  "score.pts": {
    "x": 650,
    "y": 1386,
    "w": 110,
    "h": 84,
    "lane": {
      "x": 636,
      "y": 1380,
      "w": 184,
      "h": 90
    }
  },
  "score.sub": {
    "x": 366,
    "y": 1457,
    "w": 209,
    "h": 28,
    "lane": {
      "x": 300,
      "y": 1446,
      "w": 340,
      "h": 48
    }
  },
  "continue": {
    "x": 344,
    "y": 1555,
    "w": 248,
    "h": 28,
    "lane": {
      "x": 320,
      "y": 1539,
      "w": 310,
      "h": 56
    }
  },
  "allsix": {
    "x": 394,
    "y": 1290,
    "w": 152,
    "h": 26,
    "lane": {
      "x": 300,
      "y": 1280,
      "w": 360,
      "h": 56
    }
  }
}